import { ActivatedRoute } from '@angular/router';
import { dashboardService } from '../services/dashboard/dashboard.service';
import { PubSubService } from '../service/pubSub.service';
import { BAppService } from '../service/bApp.service';
// import { homeComponent } from '../homeComponent/home.component';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var notificationComponent = (function () {
    function notificationComponent(r, mulNotify, pubsub, bAppService) {
        this.r = r;
        this.mulNotify = mulNotify;
        this.pubsub = pubsub;
        this.bAppService = bAppService;
        this.subscribe = {
            ss: {
                access: false,
                channels: {}
            },
            wic: {
                access: false,
                channels: {}
            },
            cci: {
                access: false,
                channels: {}
            }
        };
    }
    notificationComponent.prototype.ngOnInit = function () {
        var _this = this;
        // console.log(JSON.parse(JSON.stringify(this.mulNotify.dashboardObject.dashboard)))
        this.actionBarSub = this.pubsub.$sub('saveNot', function (eventObject) {
            if (eventObject == 'saveNotification') {
                if (_this.subscribe.ss.access == true || _this.subscribe.wic.access == true || _this.subscribe.cci.access == true) {
                    _this.save();
                }
                else {
                    _this.bAppService.openSnackBar("Please select atleast one dashboard.");
                }
            }
        });
        this.pubsub.$pub('tabListner', [{ id: 'routeSaveButton', buttonName: 'save', event: 'saveNot', eventAction: 'saveNotification', title: 'Save' }]);
        if (this.mulNotify.dashboardObject && this.mulNotify.dashboardObject.dashboard) {
            // removing object reference assignment
            this.subscribe = JSON.parse(JSON.stringify(this.mulNotify.dashboardObject.dashboard));
            // this.subscribe = this.mulNotify.dashboardObject.dashboard;
        }
    };
    notificationComponent.prototype.ngDoCheck = function () {
        if (this.subscribe) {
            if ((this.subscribe.ss && !this.subscribe.ss.access)) {
                this.subscribe.ss.channels['high'] = false;
                this.subscribe.ss.channels['medium'] = false;
                this.subscribe.ss.channels['low'] = false;
            }
            if ((this.subscribe.wic && !this.subscribe.wic.access)) {
                this.subscribe.wic.channels['high'] = false;
                this.subscribe.wic.channels['medium'] = false;
                this.subscribe.wic.channels['low'] = false;
            }
            if ((this.subscribe.cci && !this.subscribe.cci.access)) {
                this.subscribe.cci.channels['high'] = false;
                this.subscribe.cci.channels['medium'] = false;
                this.subscribe.cci.channels['low'] = false;
            }
        }
    };
    notificationComponent.prototype.save = function () {
        // this.pubsub.$pub('dashBoadrd', "result");
        this.mulNotify.updateDashboards(this.subscribe).then(function (result) {
            if (Object.keys(result).length > 0) {
                // this.pubsub.$pub('dashBoadrd', result);
            }
        }).catch(function (error) {
            console.error(error);
        });
    };
    notificationComponent.prototype.ngOnDestroy = function () {
        this.actionBarSub.unsubscribe();
    };
    return notificationComponent;
}());
export { notificationComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/notificationComponent/notification.component.ts.pre-build-optimizer.js